import React from 'react'
import GoogleIcon from '../../../icon/GoogleIcon'
import { OC_ERROR_MESSAGES } from '../constants/ocConstants'
import { normalizeErrorDetails } from '../../../helpers/utils'

const OcErrorStatus = ({ details }) => {
  return (
    <div className="oc-error-status-inline">
      <strong>Estado de la solicitud:</strong>
      <GoogleIcon
        name="report"
        size={20}
        className="oc-error-status-icon"
      />
      <span>
        {OC_ERROR_MESSAGES.PROCESS_ORDER_ERROR}:  {normalizeErrorDetails(details)}
      </span>
    </div>
  )
}

export default OcErrorStatus
